import React, { useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import DocPageHeader from 'components/docs/DocPageHeader';
import ConnectorManagementPanel from './ConnectorManagementPanel';
import useCustomer from 'hooks/useCustomer';
import { useLoading } from 'providers/LoadingProvider';

const ConnectorManagementCustomerPage: React.FC = () => {
  const { connectorGroups, connectors, createConnector, updateConnector, deleteConnector, error } = useCustomer();
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    showLoading();
    const timeout = setTimeout(() => {
      hideLoading();
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div>
      <DocPageHeader title="Connectors" />
      <p>Add and manage your carrier connectors here to enable automatic collection of your carrier invoice data.</p>
      {error && (
        <Alert variant="outline-danger" className="mb-3">
          {error}
        </Alert>
      )}
      <ConnectorManagementPanel
        connectors={connectors}
        createConnector={createConnector}
        updateConnector={updateConnector}
        deleteConnector={deleteConnector}
        connectorGroups={connectorGroups}
      />
    </div>
  );
};

export default ConnectorManagementCustomerPage;
